import { useTranslation } from "react-i18next";

import { ROUTES, useUserAccessLevels } from "shared";

import { FOUND_ITEM_NAMES, FoundResourceInfoRowProps } from "../types";

const FoundResourceInfoRow = ({
    resourceData,
    resourceRoute
}: FoundResourceInfoRowProps) => {
    const { t } = useTranslation();
    const { getUserAccessLevelInfo } = useUserAccessLevels();

    const { access_level, model } = resourceData;

    const itemName =
        resourceRoute === ROUTES.Devices
            ? FOUND_ITEM_NAMES.DeviceModel
            : FOUND_ITEM_NAMES.AccessLevel;

    const getResourceValue = () => {
        if (resourceRoute === ROUTES.Devices) {
            return model;
        }

        return getUserAccessLevelInfo(access_level).name;
    };

    return (
        <div>
            <span>{t(`Table##${itemName}`)}:</span>
            <span>{getResourceValue() ?? "-"}</span>
        </div>
    );
};

export default FoundResourceInfoRow;
